import React from 'react';
import CreateProductComponent from '../../../components/Admin/products/CreateProductComponent';
import { useNavigate } from 'react-router-dom';

const CreateProductPage = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/san-pham');
    }

    return <CreateProductComponent shouldRedirect={ () => redirect() } />;
}

export default CreateProductPage;